// extracted by mini-css-extract-plugin
export default {"submenu":"Submenu_submenu__q5FuJ","divider":"Submenu_divider__obmVZ","submenuList":"Submenu_submenuList__XQ+zW"};